import { gql, TypedDocumentNode } from "@apollo/client";

import { QuerySearchIntentProjectsSuggestionsArgs, SearchSuggestionsOutput } from "types/generated";
import { SEARCH_SUGGESTIONS_FRAGMENT } from "constants/suggestions";

export const SEARCH_INTENT_PROJECTS_SUGGESTIONS: TypedDocumentNode<
  {
    searchIntentProjectsSuggestions: SearchSuggestionsOutput;
  } & QuerySearchIntentProjectsSuggestionsArgs
> = gql`
  query SearchIntentProjectsSuggestions($input: SearchSuggestionsInput!) {
    searchIntentProjectsSuggestions(input: $input) {
      ...SearchSuggestionsFragment
    }
  }
  ${SEARCH_SUGGESTIONS_FRAGMENT}
`;

export const SEARCH_INTENT_PROJECTS_SUGGESTIONS_FILTERED_COUNT_FRAGMENT = gql`
  fragment SearchIntentProjectsSuggestionsFilteredCountFragment on Query {
    searchIntentProjectsSuggestions(input: $input) {
      filteredCount
    }
  }
`;
